var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.avatar)?_c('img',{attrs:{"src":_vm.avatar}}):_vm._e(),_vm._v(" "),_c('loading-overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }